import { SurfaceActionItem } from 'owa-surface-actions';
import CLPLabel from 'owa-mail-store/lib/store/schema/CLPLabel';
import { ComposeViewState } from 'owa-mail-compose-store';
import shouldMarkCLPLabelAsChecked from './shouldMarkCLPLabelAsChecked';
import { lazyShowJustificationModal } from 'owa-mail-clp';
import { ControlIcons } from 'owa-control-icons';
import { ContextualMenuItemType } from 'office-ui-fabric-react/lib/ContextualMenu';
import {
    clpLabelDropDownLearnMoreButtonText,
    clpLabelDropDownLearnMoreButtonToolTipText,
    clpLabelCannotChangeLabelModalTitle,
    clpLabelCannotChangeLabelModalSubtext,
} from './getSensitivitySubMenu.locstring.json';
import loc from 'owa-localize';
import { confirm } from 'owa-confirm-dialog';

export default function getSubMenuItems(
    labels: CLPLabel[],
    composeViewState: ComposeViewState,
    isSmimeEnabled: boolean
): SurfaceActionItem[] {
    if (!labels || labels.length <= 0) {
        return [];
    }
    let subMenuProps: SurfaceActionItem[] = [];
    let { clpViewState } = composeViewState;
    let isReplyOrForward = composeViewState.referenceItemId ? true : false;
    labels.forEach(label => {
        subMenuProps.push({
            name: label.displayName,
            title: label.tooltip,
            onClick: () => {
                if (composeViewState.IRMData && !composeViewState.IRMData.IsOwner) {
                    confirm(
                        loc(clpLabelCannotChangeLabelModalTitle), // Modal Title
                        loc(clpLabelCannotChangeLabelModalSubtext), // Subtext
                        false, // Resolve immidiately
                        { hideCancelButton: true } // Custom Confirmation Options
                    );
                } else {
                    lazyShowJustificationModal.import().then(showJustificationModal => {
                        showJustificationModal(
                            label,
                            composeViewState,
                            clpViewState,
                            isReplyOrForward
                        );
                    });
                }
            },
            key: label.id,
            disabled: isSmimeEnabled && label.isEncryptingLabel,
            canCheck: true,
            checked: shouldMarkCLPLabelAsChecked(
                label,
                composeViewState.clpViewState.selectedCLPLabel
            ),
            subMenuProps:
                label.children && label.children.length > 0
                    ? { items: getSubMenuItems(label.children, composeViewState, isSmimeEnabled) }
                    : null,
        });
    });
    return subMenuProps;
}

export function getLearnMoreSubMenuItem(learnMoreUrl: string) {
    return [
        {
            key: 'divider',
            itemType: ContextualMenuItemType.Divider,
        },
        {
            name: loc(clpLabelDropDownLearnMoreButtonText),
            title: loc(clpLabelDropDownLearnMoreButtonToolTipText),
            onClick: () => {
                window.open(learnMoreUrl, '_blank');
            },
            key: 'LearnMore',
            canCheck: false,
            checked: null,
            iconProps: {
                iconName: ControlIcons.Info,
            },
        },
    ];
}
